import { Flex } from 'antd';
import { TabAssignmentsList } from './components/TabAssignmentsList';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTable } from '@refinedev/antd';
import type { IProfessorAreaClassroom } from 'interfaces/professor_area_classrooms';
import type { IProfessorAreaEvaluationsList } from 'interfaces/professor_area/evaluations';

export const ITEMS_PER_PAGE = 5;

interface TabAssignmentsProps {
  classroomRecord: IProfessorAreaClassroom;
}

export const TabAssignments = ({ classroomRecord }: TabAssignmentsProps) => {
  const params = useParams();
  const classroomId = params.id;

  const { tableProps, setCurrent } = useTable<IProfessorAreaEvaluationsList>({
    resource: 'professor_area/classroom_assignments',
    meta: { classroomId },
    filters: {
      initial: [
        {
          field: 'filter[by_evaluation_type]',
          operator: 'eq',
          value: 'Assignment'
        }
      ]
    },
    pagination: {
      pageSize: ITEMS_PER_PAGE
    }
  });

  const handleChangePage = useCallback(
    (page: number) => {
      setCurrent(page);
    },
    [setCurrent]
  );

  return (
    <Flex vertical>
      <TabAssignmentsList
        tableProps={tableProps}
        onChangePage={handleChangePage}
        refetch={() => setCurrent(1)}
        disciplineId={classroomRecord.discipline_id}
      />
    </Flex>
  );
};
